var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 74,
    viewBox: "0 0 60 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 33.6704V33.67V15.9738C1.5 13.6723 2.93298 11.6142 5.09145 10.8155L28.0915 2.30555C29.323 1.84987 30.677 1.84987 31.9085 2.30555L54.9086 10.8155C57.067 11.6142 58.5 13.6723 58.5 15.9738V33.67C58.5 42.7172 55.7773 50.9325 50.3061 58.3584C45.1949 65.2957 38.8483 69.854 31.2512 72.1055C30.435 72.3474 29.5654 72.3474 28.7491 72.1053C21.1494 69.8517 14.8015 65.2921 9.69012 58.3546C4.21899 50.9289 1.49759 42.7149 1.5 33.6704ZM28.5 66.23V68.256L30.4378 67.6647C36.8295 65.7142 42.1521 61.858 46.3908 56.1624C50.6136 50.4884 53.0895 44.1431 53.8047 37.1527L53.9738 35.5H52.3125H31.5V7.8625V5.70812L29.4795 6.45571L6.97949 14.7807L6 15.1431V16.1875V35.335C6 35.8952 6.07935 36.5501 6.21234 37.2718L6.43866 38.5H7.6875H28.5V66.23Z",
    fill: "#013847",
    stroke: "#013847",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/SecurityIcon.38030528f52411270d977378a5ffc459.svg";
export { ForwardRef as ReactComponent };